import { GET } from '../request'

export const getIntensivosAlumno = alumnoId =>
  GET('/api/agora/alumnos/contabilidad/intensivo-alumno/list/alumno', {
    alumno: alumnoId
  })
